import { render, staticRenderFns } from "./FormatEditor.vue?vue&type=template&id=a8f075e0&scoped=true&"
import script from "./FormatEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatEditor.vue?vue&type=style&index=0&id=a8f075e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f075e0",
  null
  
)

export default component.exports